module.exports = __webpack_public_path__ + "img/PRNT_01_mono_AE_00005.2171f589.png";